__turbopack_context__.v({
  "app_light_theme": "discount-product-availability-widget-module-scss-module__Yg6eTa__app_light_theme",
  "ctaBtn": "discount-product-availability-widget-module-scss-module__Yg6eTa__ctaBtn",
  "header": "discount-product-availability-widget-module-scss-module__Yg6eTa__header",
  "map": "discount-product-availability-widget-module-scss-module__Yg6eTa__map",
  "mapLayer": "discount-product-availability-widget-module-scss-module__Yg6eTa__mapLayer",
  "marker": "discount-product-availability-widget-module-scss-module__Yg6eTa__marker",
  "markerIcon": "discount-product-availability-widget-module-scss-module__Yg6eTa__markerIcon",
  "preview": "discount-product-availability-widget-module-scss-module__Yg6eTa__preview",
  "root": "discount-product-availability-widget-module-scss-module__Yg6eTa__root",
  "shopName": "discount-product-availability-widget-module-scss-module__Yg6eTa__shopName",
  "title": "discount-product-availability-widget-module-scss-module__Yg6eTa__title",
});
